/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for CourseController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { CourseDto, RequestOptions, SchoolLevelDto, CourseLevelDto } from "../models";

@Injectable({ providedIn: "root" })
export class CourseControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    updateCourse(id: string, courseDto: CourseDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<CourseDto>;
    updateCourse(id: string, courseDto: CourseDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CourseDto>>;
    updateCourse(id: string, courseDto: CourseDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CourseDto>>;
    updateCourse(id: string, courseDto: CourseDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/courses/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: courseDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllCourses(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<CourseDto>>;
    findAllCourses(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<CourseDto>>>;
    findAllCourses(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<CourseDto>>>;
    findAllCourses(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/courses`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    createCourse(courseDto: CourseDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<CourseDto>;
    createCourse(courseDto: CourseDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CourseDto>>;
    createCourse(courseDto: CourseDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CourseDto>>;
    createCourse(courseDto: CourseDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/courses`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: courseDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findCoursesInLevels(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<SchoolLevelDto>>;
    findCoursesInLevels(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<SchoolLevelDto>>>;
    findCoursesInLevels(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<SchoolLevelDto>>>;
    findCoursesInLevels(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/courses/levels`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    assignCourseToLevel(courseLevelDto: CourseLevelDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<CourseLevelDto>;
    assignCourseToLevel(courseLevelDto: CourseLevelDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CourseLevelDto>>;
    assignCourseToLevel(courseLevelDto: CourseLevelDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CourseLevelDto>>;
    assignCourseToLevel(courseLevelDto: CourseLevelDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/courses/levels`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: courseLevelDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    removeCourseFromLevel(courseLevelId: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    removeCourseFromLevel(courseLevelId: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    removeCourseFromLevel(courseLevelId: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    removeCourseFromLevel(courseLevelId: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/courses/levels/${courseLevelId}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
